/**
 * Amostras que a documentação não monta ao vivo, ou monta num estado só,
 * porque o componente de verdade reprova no axe (WCAG 2.1 AA) nesse estado.
 *
 * Mostrar o estado defeituoso poria na documentação a violação que ela manda
 * evitar; escondê-lo calado deixaria quem lê achar que o componente está bom.
 * Por isso a amostra diz o defeito, com a razão medida de `tokens.css` pela
 * mesma conta do auditor (`medidas.ts`), e o defeito fica aqui com o trecho do
 * arquivo que o causa. A correção é do componente, fora da documentação.
 *
 * `AdminDesignSystem.spec.tsx` confere que cada trecho ainda está no arquivo:
 * quando alguém corrigir o componente, o teste reprova e pede para devolver a
 * amostra completa e tirar a entrada daqui.
 */

export interface AmostraSuspensa {
  /** Id do item no catálogo. */
  item: string;
  /** Arquivo do componente, relativo a `apps/web/src`. */
  arquivo: string;
  /** Trecho do arquivo que causa o defeito. */
  trecho: string;
  /** O que o axe acusa e o que a amostra deixa de mostrar. */
  defeito: string;
}

export const AMOSTRAS_SUSPENSAS: readonly AmostraSuspensa[] = [
  {
    item: 'notificacao',
    arquivo: 'ui/Notificacao.tsx',
    trecho: "sucesso ? 'text-success' : 'text-destructive'",
    defeito:
      'Texto --success e --destructive sobre o próprio tom a 10%: abaixo de 4,5:1 nos dois tons e nos dois temas (o token de texto é o *-text). A amostra não monta o aviso.',
  },
  {
    item: 'destructive-action-chip',
    arquivo: 'ui/DestructiveActionChip.tsx',
    trecho: "'border-destructive/30 bg-destructive/10 text-destructive'",
    defeito:
      'Texto de 10 a 12 px em --destructive e --warning sobre o próprio tom a 10%: abaixo de 4,5:1. A amostra não monta o selo.',
  },
  {
    item: 'pie-chart-card',
    arquivo: 'ui/charts/PieChartCard.tsx',
    trecho: '<Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />',
    defeito:
      'Cada fatia do Recharts é um <path role="img"> sem nome (svg-img-alt); as fatias precisam de rótulo. A amostra não monta o gráfico.',
  },
  {
    item: 'detail-summary-sidebar',
    arquivo: 'ui/DetailSummarySidebar.tsx',
    trecho: '<dt className="text-muted-foreground text-xs">Criado em</dt>',
    defeito:
      'O bloco de auditoria põe <dt>/<dd> fora de um <dl> (dlitem). A amostra mostra o resumo sem a auditoria.',
  },
  {
    item: 'multi-select-combobox',
    arquivo: 'ui/base/multi-select-combobox.tsx',
    trecho: 'text-muted-foreground/80',
    defeito:
      'O texto de exemplo (nada escolhido) vai em --muted-foreground a 80%: abaixo de 4,5:1. A amostra abre com DREs já escolhidas.',
  },
  {
    item: 'primitivo-calendar',
    arquivo: 'ui/base/calendar.tsx',
    trecho: 'day-outside text-muted-foreground opacity-50',
    defeito:
      'Os dias de fora do mês vão em --muted-foreground a 50%: abaixo de 4,5:1. A amostra esconde os dias de fora do mês.',
  },
];
